import { useUserEventLogger } from '@repo/tracking-service';
import { List } from '@zenterprise-inc/ui';

import FillRegisterCert from '@/assets/illust-icons/fill-register-cert.svg';

const CorporationHometaxList = ({ handleClick }: { handleClick: () => void }) => {
  const { sendClickEvent } = useUserEventLogger();
  return (
    <List.Basic
      left={<FillRegisterCert width={36} height={36} />}
      title={{ text: '홈택스 아이디로 조회하기', titleStyle: 'headline-18' }}
      subText={{ text: '인증서 없이 빠르게 조회해요.' }}
      listIcon
      onClick={() => {
        sendClickEvent('corps-selectauth_hometaxid');
        handleClick();
      }}
      className="page-padding cursor-pointer"
    />
  );
};

export default CorporationHometaxList;
